// ConversationTile.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./ConversationTile.css";

const ConversationTile = ({ conversation }) => {
  return (
    <article className="conversation-tile">
      <div className="conversation-tile-image">
        <img src={conversation.image} alt={conversation.title} />
      </div>
      <div className="conversation-tile-content">
        <div className="conversation-tile-header">
          <img
            src={conversation.expertLogo}
            alt="Expert Logo"
            className="expert-logo"
          />
          <div className="conversation-tile-tags">
            {conversation.tags.map((tag, index) => (
              <span key={index} className="conversation-tag">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <Link
          to={`/conversations/${conversation.slug}`}
          className="conversation-tile-title"
        >
          <h2>{conversation.title}</h2>
        </Link>
        <div className="conversation-tile-meta">
          <div className="expert-info">
            <img
              src={conversation.expertImage}
              alt={conversation.expertName}
              className="expert-image"
            />
            <div className="expert-details">
              <span className="expert-name">{conversation.expertName}</span>
              <span className="expert-title">{conversation.expertTitle}</span>
            </div>
          </div>
          <time className="conversation-date">{conversation.publishDate}</time>
        </div>
        <p className="conversation-tile-excerpt">{conversation.excerpt}</p>
      </div>
    </article>
  );
};

export default ConversationTile;
